import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rdf-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit {
  @Input() field
  constructor() { }

  ngOnInit() {
  }

}
